import SolicitacaoFaturamento from './componentes/SolicitacaoFaturamento.vue';
import SolicitacaoFaturamentoLista from './componentes/SolicitacaoFaturamentoLista.vue';
import SolicitacaoFaturamentoForm from './componentes/SolicitacaoFaturamentoForm.vue';
import SolicitacaoFaturamentoRelatorio from './componentes/SolicitacaoFaturamentoRelatorio.vue';

export default {
  path: '/solicitacao-faturamento-pfpj',
  component: SolicitacaoFaturamento,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoFaturamentoLista,
      name: 'solicitacao-faturamento-pfpj',
    },
    {
      path: 'nova',
      component: SolicitacaoFaturamentoForm,
      name: 'solicitacao-faturamento-pfpj.nova'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoFaturamentoRelatorio,
      name: 'solicitacao-faturamento-pfpj.relatorio'
    },
    {
      path: ':id',
      component: SolicitacaoFaturamentoForm,
      name: 'solicitacao-faturamento-pfpj.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-faturamento/rotas.js